import { CircuitBreakerAuthService } from "@ms/uno-services/lib/local/services/auth/CircuitBreakerAuthService";
import { HostAdaptorAuthService } from "@ms/uno-services/lib/local/services/auth/HostAdaptorAuthService";
import { RetailServicesTokenExchangeService } from "@ms/uno-services/lib/local/services/auth/RetailServicesTokenExchangeService";
import { BaseServiceFactory } from "../../base/factories/BaseServiceFactory";
/**
 * Implementation of the service provider factory for the Uno MetaOS apps
 */
export class MetaOSAppServiceFactory extends BaseServiceFactory {
    getAuthServiceProvider(ajaxClient, hostAdaptor, configProvider) {
        return () => {
            if (this.auth) {
                return this.auth;
            }
            const innerAuth = hostAdaptor.usingNestedAppAuth() && configProvider().flights.EnableNestedAppAuth
                ? new HostAdaptorAuthService(this.loggers, hostAdaptor, configProvider)
                : new RetailServicesTokenExchangeService(ajaxClient, hostAdaptor, configProvider);
            this.auth = new CircuitBreakerAuthService(innerAuth, configProvider, this.loggers);
            return this.auth;
        };
    }
}
